(window as unknown as { global: unknown }).global = window;
